<template>
    <b-card
        :title="translations.create[lang]"
        @cancel="
            () => {
                redeemedCouponsReport = false;
                allCouponsReport = false;
                giftSearch = '';
                $emit('cancel');
            }
        "
        @submit="sendForm"
        :error-message="errorMessage"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancellazione' }"
    >
        <v-menu
            v-model="menu"
            max-height="300"
            offset-y
            :close-on-content-click="false"
            nudge-bottom="3"
        >
            <template v-slot:activator="{ on }">
                <v-text-field
                    v-model="giftSearch"
                    ref="search"
                    :label="translations.giftCategory[lang]"
                    color="secondary"
                    outlined
                    dense
                    clearable
                    v-on="on"
                    hide-details="auto"
                    autocomplete="off"
                    :append-icon="menu ? icons.mdiMenuUp : icons.mdiMenuDown"
                    :loading="loading"
                    @click:append="
                        () => {
                            menu = !menu;
                            $refs.search.focus();
                        }
                    "
                ></v-text-field>
            </template>
            <v-list dense>
                <template v-if="getGiftCategories.length">
                    <v-list-item
                        v-for="category in getGiftCategories"
                        :key="category.gift_category_id"
                        class="pl-3"
                        @click="
                            () => {
                                multipleCoupon.gift_category_id =
                                    category.gift_category_id;
                                giftSearch = category.name[lang];
                                menu = false;
                            }
                        "
                    >
                        <v-list-item-title>
                            <v-row no-gutters justify="space-between">
                                <v-col cols="auto">
                                    {{ category.name[lang] }}
                                </v-col>
                            </v-row>
                        </v-list-item-title>
                    </v-list-item>
                </template>
                <v-list-item v-else>
                    <v-list-item-title v-text="'No Data'"></v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>

        <b-text-field
            :label="translations.name[lang]"
            v-model="multipleCoupon.gift_title"
        ></b-text-field>

        <b-textarea
            :label="translations.giftDescription[lang]"
            v-model="multipleCoupon.gift_description"
        ></b-textarea>

        <b-text-field
            :label="translations.priceCreate[lang]"
            type="number"
            v-model="multipleCoupon.price"
        ></b-text-field>

        <b-text-field
            :label="translations.totalCoupons[lang]"
            type="number"
            v-model="multipleCoupon.maximum"
        ></b-text-field>

        <b-text-field
            :label="translations.validDays[lang]"
            type="number"
            v-model="multipleCoupon.valid_days"
        ></b-text-field>

        <b-text-field
            :label="translations.masterCoupon[lang]"
            v-model="multipleCoupon.code"
        ></b-text-field>

        <v-checkbox
            v-model="redeemedCouponsReport"
            color="secondary"
            hide-details
            class="pt-0 mt-3"
        >
            <template v-slot:label>
                <h4 class="subtitle-2">
                    {{ translations.sendReportRedeemedCouponsReport[lang] }}
                </h4>
            </template>
        </v-checkbox>

        <template v-if="redeemedCouponsReport">
            <b-text-field
                :rules="emailRules"
                :label="translations.emailAddress1[lang]"
                v-model="
                    multipleCoupon.notification.redeemed_coupons_report
                        .emails[0]
                "
            ></b-text-field>

            <b-text-field
                :rules="emailRules"
                :label="translations.emailAddress2[lang]"
                v-model="
                    multipleCoupon.notification.redeemed_coupons_report
                        .emails[1]
                "
            ></b-text-field>

            <b-text-field
                :rules="emailRules"
                :label="translations.emailAddress3[lang]"
                v-model="
                    multipleCoupon.notification.redeemed_coupons_report
                        .emails[2]
                "
            ></b-text-field>

            <v-select
                v-model="
                    multipleCoupon.notification.redeemed_coupons_report
                        .frequency
                "
                :label="translations.frequencyOfReport[lang]"
                :items="frequency"
                item-text="text"
                item-value="value"
                outlined
                dense
                class="mt-3"
                color="secondary"
                item-color="secondary"
            >
                <template v-slot:append>
                    <v-icon :title="translations.frequencyOfReportHelp[lang]">{{
                        icons.mdiHelpCircle
                    }}</v-icon>
                </template>
            </v-select>
        </template>

        <v-checkbox
            v-model="allCouponsReport"
            color="secondary"
            hide-details
            class="pt-0 mt-3"
        >
            <template v-slot:label>
                <h4 class="subtitle-2">
                    {{ translations.sendReportAllCouponsStatusReport[lang] }}
                </h4>
            </template>
        </v-checkbox>

        <template v-if="allCouponsReport">
            <b-text-field
                :rules="emailRules"
                :label="translations.emailAddress1[lang]"
                v-model="
                    multipleCoupon.notification.all_coupons_report.emails[0]
                "
            ></b-text-field>

            <b-text-field
                :rules="emailRules"
                :label="translations.emailAddress2[lang]"
                v-model="
                    multipleCoupon.notification.all_coupons_report.emails[1]
                "
            ></b-text-field>

            <b-text-field
                :rules="emailRules"
                :label="translations.emailAddress3[lang]"
                v-model="
                    multipleCoupon.notification.all_coupons_report.emails[2]
                "
            ></b-text-field>

            <v-select
                v-model="
                    multipleCoupon.notification.all_coupons_report.frequency
                "
                :label="translations.frequencyOfReport[lang]"
                :items="frequency"
                item-text="text"
                item-value="value"
                outlined
                dense
                class="mt-3"
                color="secondary"
            >
                <template v-slot:append>
                    <v-icon :title="translations.frequencyOfReportHelp[lang]">{{
                        icons.mdiHelpCircle
                    }}</v-icon>
                </template>
            </v-select>
        </template>
    </b-card>
</template>

<script>
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import debounce from "lodash/debounce";
import translations from "@/utils/translations/loyaltyPanel/multipleCoupons";
import { mdiMenuUp, mdiMenuDown, mdiHelpCircle } from "@mdi/js";

export default {
    name: "CreateForm",

    mixins: [translations],

    data: () => ({
        icons: {
            mdiMenuUp,
            mdiMenuDown,
            mdiHelpCircle,
        },
        redeemedCouponsReport: false,
        allCouponsReport: false,
        menu: false,
        giftSearch: "",
        emailRules: [
            (v) =>
                !v ||
                /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                "E-mail must be valid",
        ],
        frequency: [
            {
                text: "Daily",
                value: "daily",
            },
            {
                text: "Weekly",
                value: "weekly",
            },
            {
                text: "Monthly",
                value: "monthly",
            },
        ],
    }),

    computed: {
        ...mapState(["loading", "errorMessage"]),
        ...mapState("loyaltyPanel/multipleCoupons", ["successCode"]),
        ...mapGetters({
            getGiftCategories: "loyaltyPanel/giftCategories/getGiftCategories",
        }),

        multipleCoupon: {
            get() {
                return this.$store.state.loyaltyPanel.multipleCoupons
                    .multipleCoupon;
            },
            set(val) {
                this.setMultipleCoupon(val);
            },
        },

        lang() {
            return this.$route.params.lang;
        },
    },

    methods: {
        ...mapActions({
            fetchGiftCategories:
                "loyaltyPanel/giftCategories/fetchGiftCategories",
            createCoupon: "loyaltyPanel/multipleCoupons/createCoupon",
        }),
        ...mapMutations({
            setMultipleCoupon: "loyaltyPanel/multipleCoupons/setMultipleCoupon",
        }),

        handleGiftSearch() {
            this.fetchGiftCategories(`?q=${this.giftSearch}`);
        },

        async sendForm() {
            await this.createCoupon();
            this.giftSearch = "";
        },
    },

    mounted() {
        this.fetchGiftCategories("");
    },

    watch: {
        giftSearch(val) {
            if (val) {
                this.menu = true;
                this.debouncedGiftSearch();
            } else {
                this.fetchGiftCategories(`?page=1`);
                this.multipleCoupon.gift_category_id = null;
            }
        },

        successCode(val) {
            if (val) {
                this.redeemedCouponsReport = false;
                this.allCouponsReport = false;
            }
        },
    },

    created() {
        this.debouncedGiftSearch = debounce(this.handleGiftSearch, 500);
    },
};
</script>

<style scoped></style>
